'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getDisplayName = function getDisplayName(BaseComponent) {
    if (typeof BaseComponent === 'string') {
        return BaseComponent;
    }
    if (!BaseComponent) {
        return undefined;
    }
    return BaseComponent.displayName || BaseComponent.name || 'Component';
};

exports.default = getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-copy-provider/dist/getDisplayName.js
// module id = 1622
// module chunks = 4 5